// Recently Viewed Products Tracker & Display Logic
(function() {
  const STORAGE_KEY = 'recentlyViewedProducts';
  const MAX_PRODUCTS = 6; 

  // 1. Tracking Funktion
  function trackProductView() {
    const productData = document.querySelector('[data-product-id]');
    if (!productData) return;

    const productId = productData.getAttribute('data-product-id');
    // Fallback für Handle, falls Attribut fehlt
    const productHandle = productData.getAttribute('data-product-handle') || window.location.pathname.split('/').pop();
    
    let viewedProducts = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    
    // Entfernen, falls schon vorhanden (um es nach vorne zu holen)
    viewedProducts = viewedProducts.filter(p => p.id !== productId);
    
    // Vorne anfügen
    viewedProducts.unshift({
      id: productId,
      handle: productHandle,
      timestamp: Date.now()
    });
    
    // Limitieren
    viewedProducts = viewedProducts.slice(0, MAX_PRODUCTS);
    
    localStorage.setItem(STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  // 2. HTML Karte generieren
  function createProductCard(product) {
    // Preise formatieren (Sicherheitscheck falls null)
    const price = (product.price / 100).toFixed(2);
    const comparePrice = product.compare_at_price ? (product.compare_at_price / 100).toFixed(2) : null;
    const currency = window.Shopify?.currency?.active || 'CHF';
    const vendor = product.vendor || '';
    const secondaryImage = product.images && product.images.length > 1 ? product.images[1] : null;

    return `
      <li class="grid__item">
        <div class="product-card card-wrapper">
          <div class="product-card__image">
            <a href="/products/${product.handle}" class="full-unstyled-link">
              <img src="${product.featured_image}" alt="${product.title}" loading="lazy" width="100%">
              ${secondaryImage ? `<img src="${secondaryImage}" alt="${product.title}" class="product-card__image-secondary" loading="lazy" width="100%">` : ''}
            </a>
          </div>
          <div class="product-card__info underline-links-hover">
            <h3 class="product-card__title card__heading h5">
              <a href="/products/${product.handle}" class="product-card__link full-unstyled-link">${product.title}</a>
            </h3>
            ${vendor ? `<p class="product-card__vendor">${vendor}</p>` : ''}
            <div class="product-card__price">
              ${comparePrice ? `<span class="price--compare" style="text-decoration:line-through; margin-right:5px;">${currency} ${comparePrice}</span>` : ''}
              <span class="price">${currency} ${price}</span>
            </div>
          </div>
        </div>
      </li>
    `;
  }

  // 3. Logik zum Anzeigen / Verstecken der Container (Deine displayshown Logik)
  function toggleEmptyState(hasProducts) {
    const noreview = document.getElementById("norev");
    const view = document.getElementById("viewed-true"); // Dein Container braucht diese ID!

    if (hasProducts) {
      // Produkte da: Zeige Viewed, Verstecke NoRev
      if (view) view.style.display = 'block';
      if (noreview) noreview.style.display = 'none';
    } else {
      // Keine Produkte: Verstecke Viewed, Zeige NoRev (oder entferne display style)
      if (view) view.style.display = 'none';
      if (noreview) noreview.style.removeProperty('display');
    }
  }

  // 4. Laden und Rendern
  async function loadRecentlyViewed() {
    // Wir suchen den Container. WICHTIG: Er muss id="viewed-true" haben ODER data-recently-viewed
    const container = document.getElementById('viewed-true') || document.querySelector('[data-recently-viewed]');
    
    if (!container) return; // Wenn Container im HTML fehlt, abbrechen

    const viewedProducts = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    
    // Aktuelles Produkt filtern
    const currentProductId = document.querySelector('[data-product-id]')?.getAttribute('data-product-id');
    const productsToShow = viewedProducts.filter(p => p.id !== currentProductId);

    // Duplikate entfernen
    const uniqueProducts = [];
    const seenIds = new Set();
    for (const product of productsToShow) {
      if (!seenIds.has(product.id)) {
        seenIds.add(product.id);
        uniqueProducts.push(product);
      }
    }

    // CHECK: Ist die Liste leer?
    if (uniqueProducts.length === 0) {
      toggleEmptyState(false); // Ruft deine Logik auf -> Zeige "norev"
      return;
    }

    // Hole Daten von Shopify
    const productHandles = uniqueProducts.map(p => p.handle).slice(0, 5); // Max 5 anzeigen
    const productGrid = container.querySelector('[data-product-grid]');
    
    if (productGrid) {
      productGrid.innerHTML = ''; // Leeren

      for (const handle of productHandles) {
        try {
          const response = await fetch(`/products/${handle}.js`);
          if (!response.ok) throw new Error('Product not found'); // Fehler abfangen
          const product = await response.json();
          
          const productCard = createProductCard(product);
          productGrid.insertAdjacentHTML('beforeend', productCard);
        } catch (error) {
          console.error('Error loading product:', handle, error);
        }
      }
    }

    // Wenn wir hier sind, wurden Produkte geladen -> Container anzeigen
    toggleEmptyState(true); // Ruft deine Logik auf -> Verstecke "norev"
  }

  // 5. Initialisierung
  function init() {
    trackProductView();
    loadRecentlyViewed();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();